import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CartPage from '../../components/Cart/CartPage';
import * as EnvActions from '../../actions/environment';

const mapStateToProps = state => ({ setup: state.environment.setup, shop: state.environment.shop, productList: state.environment.productList, navigation: state.environment.navigation });
const mapDispatchToProps = dispatch => bindActionCreators(EnvActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CartPage);



// WEBPACK FOOTER //
// ./containers/pages/CartPage.jsx